@if (bundledTests[0]) {
  <app-bundle-form
    [test]="bundledTests[0]"
    [bundledTests]="bundledTests"
    action="{{ 'view' | translate }}"
    [isDisabled]="true">
  </app-bundle-form>
}

